export const selectMustHideDonateForever = (state) =>
  state.mustHideDonateForever;

export const selectMustShowDonate = (state) =>
  !state.mustHideDonateForever &&
  !['2wYwGVoxrvSLozIeN2svb88dvA53', 'hmXoM9bAwAUxFIF7HPevbQKHD1a2'].includes(
    state.user?.uid,
  ) &&
  state.mustShowDonate;
